// Colors for the four focus areas. Transformation is separate from the three Guide Partner themes.
export const CALL_THEMES = {
  parenting: {
    label: 'Parenting',
    chip: 'border-teal-500 bg-teal-500/20 text-teal-800 dark:text-teal-200',
    dot: 'bg-teal-500',
  },
  marriage: {
    label: 'Marriage',
    chip: 'border-rose-500 bg-rose-500/20 text-rose-800 dark:text-rose-200',
    dot: 'bg-rose-500',
  },
  work: {
    label: 'Work',
    chip: 'border-amber-500 bg-amber-500/20 text-amber-800 dark:text-amber-200',
    dot: 'bg-amber-500',
  },
  spiritual_growth: {
    label: 'Transformation',
    chip: 'border-violet-500 bg-violet-500/20 text-violet-800 dark:text-violet-200',
    dot: 'bg-violet-500',
  },
};

const parseDay = (value) => {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12) : null;
};

export const formatCallDate = (value, options = { weekday: 'short', month: 'short', day: 'numeric' }) => {
  const date = parseDay(value);
  return date ? date.toLocaleDateString('en-US', options) : '';
};

// Every month from the first call to the last call (empty months included), calls grouped inside each.
export const groupCallsByMonth = (calls) => {
  const dated = (Array.isArray(calls) ? calls : []).filter((call) => call && parseDay(call.date));
  if (dated.length === 0) return [];
  const keys = dated.map((call) => call.date.slice(0, 7)).sort();
  let [year, month] = keys[0].split('-').map(Number);
  const [lastYear, lastMonth] = keys[keys.length - 1].split('-').map(Number);
  const months = [];
  while (year < lastYear || (year === lastYear && month <= lastMonth)) {
    const key = `${year}-${String(month).padStart(2, '0')}`;
    months.push({
      key,
      label: formatCallDate(`${key}-01`, { month: 'long', year: 'numeric' }),
      calls: dated.filter((call) => call.date.startsWith(key)).sort((a, b) => a.date.localeCompare(b.date)),
    });
    month += 1;
    if (month > 12) { month = 1; year += 1; }
  }
  return months;
};

export const describeAssignee = (call) => {
  if (call?.status === 'launch') return 'Kevin hosts';
  if (call?.status === 'open') return 'Nobody assigned yet';
  const assignee = call?.assignee;
  if (!assignee) return '';
  return assignee.type === 'guest'
    ? `${assignee.name} (guest, up to ${assignee.max_minutes || 30} min)`
    : `${assignee.name || assignee.email} (Guide Partner)`;
};
